import React from 'react';
import classNames from 'classnames';
import { Icon } from 'Components';
import { ReportTableTab } from '../../TrainingReports.types';
import { REPORT_TABS } from '../TrainingTable.constants';
import styles from './ReportTabs.module.scss';
import { useTranslation } from 'react-i18next';

interface ReportTabsProps {
	value: ReportTableTab;
	onChange: (tab: ReportTableTab) => void;
	className?: string;
}

const ReportTabs: React.FC<ReportTabsProps> = ({
	value,
	onChange,
	className
}) => {
	const { t } = useTranslation();

	return <div className={classNames(styles.root, className)} role="tablist">
	{REPORT_TABS.map((tab) => (
		<button
			key={tab.key}
			type="button"
			role="tab"
			aria-selected={value === tab.key}
			className={classNames(styles.tab, {
				[styles['tab--active']]: value === tab.key
			})}
			onClick={() => onChange(tab.key)}
		>
			<Icon type={tab.icon} role="img" className={styles.icon} />
			<span className={styles.label}>{t(tab.label)}</span>
		</button>
	))}
</div>
}

export default ReportTabs;
